import { render, staticRenderFns } from "./AnswerRequest.vue?vue&type=template&id=356f068e&scoped=true"
import script from "./AnswerRequest.vue?vue&type=script&lang=js"
export * from "./AnswerRequest.vue?vue&type=script&lang=js"
import style0 from "./AnswerRequest.vue?vue&type=style&index=0&id=356f068e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f068e",
  null
  
)

export default component.exports